import Script from 'next/script';
import { TOrderDetails } from 'types/OrderDetails';

export function getAdtractionProductCategory(
  drawSchedulePlans: TOrderDetails['drawSchedulePlans'],
) {
  const firstSchedule = drawSchedulePlans?.[0];
  if (!firstSchedule) {
    return undefined;
  }
  const drawDayCount = drawSchedulePlans.length;

  const planCode = firstSchedule.drawTypePlan.code;
  switch (planCode) {
    case 'PREMIUM':
      return drawDayCount === 1
        ? 'LotterySubscription'
        : 'LotterySubscriptionTwice';
    case 'LITE':
      return drawDayCount === 1
        ? 'LotteryLiteSubscription'
        : 'LotteryLiteSubscriptionTwice';
    case 'FREEMIUM':
      return 'LotteryFreemiumSubscription';
  }
  return undefined;
}

const AdtractionTag = () => (
  <Script
    id="AdtractionTag"
    src="https://in.daymade.co.uk/jsTag?ap=2039711333"
    defer
  />
);

export default AdtractionTag;
